import React, {useEffect, useRef, useState} from "react";
import { useNavigate, useLocation } from "react-router-dom";
// import {useGetUserQuery, useCreatePaymentMutation, useGetPaymentsQuery} from "../services/endpoints/user.api";
// import logo from "../assets/media/logo_pay.png";
// import { QRCodeCanvas } from 'qrcode.react';  // Importa il componente QRCode
import Header from './base/HeaderComponent'
import Footer from "./base/FooterComponent";
import './Login.css';
import './Profile.css';
import {useCreateChatMutation, useLoginMutation, useMeQuery, useLazyOperatorsQuery} from "../services/endpoints/user.api";
import {updateAccessToken} from "../services/userAuthSlice";

const Profile = () => {
    const navigate = useNavigate(); // Usa useNavigate per ottenere la funzione di navigazione

    const [createChat, { isLoading }] = useCreateChatMutation(); // Hook RTK
    const [triggerGetOperators, { data: operatorsData, isLoading: isLoadingOperators }] = useLazyOperatorsQuery();
    const [room, setRoom] = useState('');
    const [showChatRoom, setShowChatRoom] = useState(false);
    const [showChatRoomAlert, setShowChatRoomAlert] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null); // <-- errore locale

    const { data: userData, isLoading: isMeLoading, isSuccess } = useMeQuery(undefined, {
        pollingInterval: 30000, // ogni 60.000 ms = 1 minuto
        skip: false, // ogni 60.000 ms = 1 minuto
    });
    //
    //
    // let shouldPoll = userData?.firestoreUser.activeSession === true;

    // const { data: pollingUserData } = useMeQuery(undefined, {
    //     // skip: !shouldPoll, // attiva polling solo se activeSession === true
    //     // pollingInterval: shouldPoll ? 30000 : 0,
    // });

    // let finalData = pollingUserData || userData;
    let finalData = userData;

    // Redirigi se non è autenticato
    useEffect(() => {
        if (isMeLoading && !isSuccess) {
            navigate("/login");
        }
    }, [isSuccess, isMeLoading, navigate]);

    useEffect(() => {
        let timeout;

        if (errorMessage || showChatRoomAlert) {
            timeout = setTimeout(() => {
                setErrorMessage(null);
                setShowChatRoomAlert(false);
            }, 3000); // 3 secondi
        }

        return () => clearTimeout(timeout);
    }, [errorMessage, showChatRoom]);

    const formatTime = (ms) => {
        const totaleSecondi = Math.floor(ms / 1000);
        const minuti = Math.floor(totaleSecondi / 60);
        const secondi = totaleSecondi % 60;

        const parteMinuti = minuti > 0 ? `${minuti} ${minuti === 1 ? "minuto" : "minuti"}` : "";
        const parteSecondi = `${secondi} ${secondi === 1 ? "secondo" : "secondi"}`;

        return parteMinuti ? `${parteMinuti} e ${parteSecondi}` : parteSecondi;
    }
    const handleSubmit = async () => {
        try {
            if(!finalData?.firestoreUser.availableTime)
                navigate('/#prezzi')
            if(showChatRoom) {
                window.open(process.env.REACT_APP_ROCKET_CHAT_API
                +'/home?resumeToken=' + localStorage.getItem('token') + '&redirect=/group/'+ room, '_blank');
            } else {
                const operator = await triggerGetOperators().unwrap();
                if (operator.success && operator.data) {

                    const result = await createChat({usernames: [operator.data.username, finalData.firestoreUser.username]}).unwrap()

                    if (result.success) {
                        setRoom(result.room.fname)
                        setShowChatRoom(true)
                        setShowChatRoomAlert(true)
                    } else {
                        setErrorMessage('Errore nella creazione della chat'); // reset in caso di successo
                    }
                } else {
                    setErrorMessage('Operatore al momento non disponibile'); // reset in caso di successo
                }
            }
        } catch (err) {
            console.error("Login error", err);
            if(err.status === 401) {
                setErrorMessage("Username o password errati.");
            } else {
                setErrorMessage("Errore durante il login. Riprova.");
            }
        }
    };
    const goToChats = async () => {
        window.open(process.env.REACT_APP_ROCKET_CHAT_API
        +'/home?resumeToken=' + localStorage.getItem('token'), '_blank');
    };




    return (
        <div>
            <Header />
            <section className="h-100 gradient-custom-2">
                <div className="container py-5 h-100">
                    <div className="row d-flex justify-content-center">
                        <div className="col col-lg-9 col-xl-8">
                            <div className="card">
                                <div
                                    className="rounded-top text-white d-flex flex-row"
                                    style={{ backgroundColor: '#000', height: '200px' }}
                                >
                                    <div className="ms-4 mt-5 d-flex flex-column" style={{ width: '150px' }}>
                                        <img
                                            // src="https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-profiles/avatar-1.webp"
                                            src="/user.png"
                                            alt="Generic placeholder"
                                            className="img-fluid img-thumbnail mt-4 mb-2"
                                            style={{ width: '150px', zIndex: 1 }}
                                        />
                                        {/*<button*/}
                                        {/*    type="button"*/}
                                        {/*    className="btn btn-outline-dark text-body"*/}
                                        {/*    style={{ zIndex: 1 }}*/}
                                        {/*>*/}
                                        {/*    Edit profile*/}
                                        {/*</button>*/}
                                    </div>
                                    <div className="ms-3" style={{ marginTop: '130px' }}>
                                        <h5>{finalData?.data.name}</h5>
                                        {/*<p>New York</p>*/}
                                    </div>
                                </div>

                                <div className="p-4 text-black bg-body-tertiary">
                                    <div className="d-flex justify-content-end text-center py-1 text-body">
                                        <div className="d-flex align-items-center gap-2">
                                            <span className={`status-dot ${finalData?.firestoreUser.activeSession ? "online" : "offline"}`}></span>
                                            <div>
                                                <p className="small text-muted mb-0">Sessione attiva</p>
                                            </div>
                                        </div>
                                        <div className="px-3">
                                            <p className="mb-1 h5">{formatTime(finalData?.firestoreUser.availableTime)}</p>
                                            <p className="small text-muted mb-0">Tempo disponibile</p>
                                        </div>
                                    </div>
                                </div>

                                <div className="card-body p-4 text-black">
                                    <div className="mb-5 text-body">
                                        {/*<p className="lead fw-normal mb-1">About</p>*/}
                                        {errorMessage && (
                                            <div className="alert alert-danger" role="alert">
                                                {errorMessage}
                                            </div>
                                        )}
                                        {showChatRoomAlert && (
                                            <div className="alert alert-success" role="alert">
                                                Sessione creata con successo!
                                            </div>
                                        )}
                                        <div className="p-4 bg-body-tertiary">
                                            {finalData?.firestoreUser.activeSession ? (
                                                <button className="btn btn-primary w-100 py-2" type="submit" onClick={goToChats}>Vai alla chat</button>
                                           ) : ( <button className="btn btn-primary w-100 py-2" type="submit" disabled={isLoading} onClick={handleSubmit}>
                                                {isLoading ? (
                                                    <>
                                                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                        Richiesta in corso...
                                                    </>
                                                ) : (
                                                     !showChatRoom ? !finalData?.firestoreUser.availableTime ? "Acquista pacchetti" : "Richiedi Chat" :
                                                         "Vai alla chat"
                                                )}
                                            </button>)}
                                        </div>
                                    </div>

                                    {/*<div className="d-flex justify-content-between align-items-center mb-4 text-body">*/}
                                    {/*    <p className="lead fw-normal mb-0">Recent photos</p>*/}
                                    {/*    <p className="mb-0">*/}
                                    {/*        <a href="#!" className="text-muted">Show all</a>*/}
                                    {/*    </p>*/}
                                    {/*</div>*/}

                                    {/*<div className="row g-2">*/}
                                    {/*    <div className="col mb-2">*/}
                                    {/*        <img*/}
                                    {/*            src="https://mdbcdn.b-cdn.net/img/Photos/Lightbox/Original/img%20(112).webp"*/}
                                    {/*            alt="image 1"*/}
                                    {/*            className="w-100 rounded-3"*/}
                                    {/*        />*/}
                                    {/*    </div>*/}
                                    {/*    <div className="col mb-2">*/}
                                    {/*        <img*/}
                                    {/*            src="https://mdbcdn.b-cdn.net/img/Photos/Lightbox/Original/img%20(107).webp"*/}
                                    {/*            alt="image 2"*/}
                                    {/*            className="w-100 rounded-3"*/}
                                    {/*        />*/}
                                    {/*    </div>*/}
                                    {/*</div>*/}
                                    {/*<div className="row g-2">*/}
                                    {/*    <div className="col">*/}
                                    {/*        <img*/}
                                    {/*            src="https://mdbcdn.b-cdn.net/img/Photos/Lightbox/Original/img%20(108).webp"*/}
                                    {/*            alt="image 3"*/}
                                    {/*            className="w-100 rounded-3"*/}
                                    {/*        />*/}
                                    {/*    </div>*/}
                                    {/*    <div className="col">*/}
                                    {/*        <img*/}
                                    {/*            src="https://mdbcdn.b-cdn.net/img/Photos/Lightbox/Original/img%20(114).webp"*/}
                                    {/*            alt="image 4"*/}
                                    {/*            className="w-100 rounded-3"*/}
                                    {/*        />*/}
                                    {/*    </div>*/}
                                    {/*</div>*/}

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    );

};

export default Profile;
